import axios from 'axios'

import Sessions from './sessions'
import Users from './users'
import Schemas from './schemas'
import Relations from './relations'
import Objects from './objects'
import Roles from './roles'

const secToken = 'token'
const secRefreshToken = 'refresh_token'
const secExpiresAt = 'expires_at'
// options:
//
// {
//    "url": "https://url_of_your_backd_server", (required)
//    "api_key": "this_is_your_api_key",         (required)
//    "per_page": 123                            (optional, default: 20)
// }
//
export default class Backd {

  constructor (options) {
    this._name = 'backd-js'
    if (typeof options.url !== 'string' || typeof options.api_key !== 'string') {
      throw new Error('missing required options to instance the client')
    }
    if (options['per_page'] === undefined) {
      options['per_page'] = 20
    }
    if (options['timeout'] === undefined) {
      options['timeout'] = 5000
    }
    this._security = {}
    this.clearSecurity()
    if (process.browser) {
      this.setToken(localStorage.getItem(secToken, ''))
      this.setRefreshToken(localStorage.getItem(secRefreshToken, ''))
      this.setExpiresAt(localStorage.getItem(secExpiresAt, 0))
    }
    this._axios = axios.create({
      baseURL: options.url,
      headers: {
        'X-API-Key': options.api_key,
        'Content-Type': 'application/json'
      },
      timeout: options.timeout
    })
    this._options = options
  }

  get name () {
    return this._name
  }

  setToken (value) {
    this._security[secToken] = value
    if (process.browser) {
      localStorage.setItem(secToken, value)
    }
  }

  setRefreshToken (value) {
    this._security[secRefreshToken] = value
    if (process.browser) {
      localStorage.setItem(secRefreshToken, value)
    }
  }

  setExpiresAt (value) {
    this._security[secExpiresAt] = value
    if (process.browser) {
      localStorage.setItem(secExpiresAt, value)
    }
  }

  clearSecurity () {
    this._security[secToken] = ''
    this._security[secRefreshToken] = ''
    this._security[secExpiresAt] = 0
    this._me = null
    if (process.browser) {
      localStorage.setItem(secToken, '')
      localStorage.setItem(secRefreshToken, '')
      localStorage.setItem(secExpiresAt, 0)
    }
  }

  sessions () {
    return new Sessions('sessions', this)
  }

  users () {
    return new Users('users', this)
  }

  schemas () {
    return new Schemas('schemas', this)
  }

  relations () {
    return new Relations('relations', this)
  }

  objects (name) {
    return new Objects('objects/' + name, this)
  }

  roles () {
    return new Roles('roles', this)
  }
}



// WEBPACK FOOTER //
// ./src/index.js